module.exports = __webpack_public_path__ + "dashboard-graphic.1e4f0c.svg";